import store from '@/store'
import router from '@/router'
import * as apiCommon from '@/api/common'
import * as apiQA from '@/api/qa'
import * as _ from 'lodash'
import { removeNeedlessTagsForWLJP } from '@/util/common'

const qaRelatedInfo = {
  namespaced: true,
  state: {

    // 関連情報ウィンドウ表示フラグ
    visibleRelatedData: false,
    // 新旧対照表ウィンドウ表示フラグ
    visibleOldAndNewMappings: false,

    // 起動元(current_contents=内容現在、related_info=関連情報)
    from: '',

    // QAタイトル
    qaTitle: '',

    // 関連情報データ連携対象(データ取得するWLJ APIの種類を指定するキー)
    target: '',
    // 関連情報キー(関連情報・内容現在ページ取得用のキー)
    key: '',
    // 現在の関連情報タイトル
    title: '',

    // ### 内容現在関係データ ###
    // 内容現在欄外の日付情報文言
    current_contents_message: '',
    // 内容現在リスト
    current_contents_list: [],

    // WLJPコンテンツのデータタイプ(list=一覧画面、detail=詳細画面)
    wljpDataType: 'list',
    // WLJPコンテンツの内容(HTML)
    wljpContent: '',
    // WLJPコンテンツのURLリンク
    wljpLink: '',
    // WLJPコンテンツのURLリンクフラグ
    wljpLinkFlag: true,
    // WLJPコンテンツのリスト
    wljpList: [],
    // 前のページのチャンクNo
    wljpPreChunkNumber: 0,
    // 次のページのチャンクNo
    wljpNextChunkNumber: 0,

    // 前にAPIにリクエストしたパラメータ(履歴管理用)
    prevHistory: {},
    // 履歴
    histories: [],
    // popHistoryの戻り値格納用
    popHistoryReturnParams: {},

    // 内容現在データロード完了フラグ
    isCurrentContentsLoaded: false,
    // WLJPコンテンツデータロード完了フラグ
    isWLJPContentsLoaded: false,

    // 設問印刷しきい値
    wljp_print_threshold: 0
  },
  getters: {
  },
  mutations: {
    clearContentsData(state) {
      state.current_contents_message = ''
      state.current_contents_list = []
      state.wljpContent = ''
      state.wljpLink = ''
      state.wljpLinkFlag = true
      state.wljpList = []
      state.wljpPreChunkNumber = 0
      state.wljpNextChunkNumber = 0
    },
    setVisibleRelatedData(state, visibleRelatedData) {
      state.visibleRelatedData = visibleRelatedData
    },
    setVisibleOldAndNewMappings(state, visibleOldAndNewMappings) {
      state.visibleOldAndNewMappings = visibleOldAndNewMappings
    },
    setQaTitle(state, qaTitle) {
      state.qaTitle = qaTitle
    },
    setValue(state, { key, value }) {
      state[key] = value
    },
    setValues(state, { from, target, key, title }) {
      state.from = from
      state.target = target
      state.key = key
      state.title = title
    },
    setPrevHistory(state, history) {
      state.prevHistory = history
    },
    pushHistory(state, history) {
      state.histories.push(history)
    },
    popHistory(state) {
      const resultParams = state.histories.pop()
      state.popHistoryReturnParams = resultParams
    },
    clearHistory(state) {
      state.prevHistory = {}
      state.histories = []
    },
    setCurrentContentsLoaded(state, isCurrentContentsLoaded) {
      state.isCurrentContentsLoaded = isCurrentContentsLoaded
    },
    setWLJPContentsLoaded(state, isWLJPContentsLoaded) {
      state.isWLJPContentsLoaded = isWLJPContentsLoaded
    }
  },
  actions: {
    /**
     * コンテンツ関係のデータをクリア
     */
    clearContentsData({ commit }) {
      commit('clearContentsData')
    },

    /**
     * 関連情報ウィンドウ表示フラグの設定
     */
    setVisibleRelatedData({ commit }, visibleRelatedData) {
      commit('setVisibleRelatedData', visibleRelatedData)
    },

    /**
     * 新旧対照表ウィンドウ表示フラグの設定
     */
    setVisibleOldAndNewMappings({ commit }, visibleOldAndNewMappings) {
      commit('setVisibleOldAndNewMappings', visibleOldAndNewMappings)
    },

    /**
     * QAタイトルの設定
     */
    setQaTitle({ commit }, qaTitle) {
      commit('setQaTitle', qaTitle)
    },

    /**
     * パラメータ名を指定して値を更新する
     * @param {string} キー（パラメータ名）
     * @param {*} 値
     */
    setValue({ commit }, { key, value }) {
      commit('setValue', { key, value })
    },

    /**
     * 関連情報・内容現在ページ取得（WLJP連携）APIにリクエストするパラメータを設定
     */
    setValues({ commit }, { from, target, key, title }) {
      commit('setValues', { from, target, key, title })
    },

    // 関連情報の履歴をクリア
    clearHistory({ commit }) {
      commit('clearHistory')
    },
    
    /**
     * 内容現在データロード完了フラグを設定
     */
    setCurrentContentsLoaded({ commit }, isCurrentContentsLoaded) {
      commit('setCurrentContentsLoaded', isCurrentContentsLoaded)
    },

    /**
     * WLJPコンテンツデータロード完了フラグを設定
     */
    setWLJPContentsLoaded({ commit }, isWLJPContentsLoaded) {
      commit('setWLJPContentsLoaded', isWLJPContentsLoaded)
    },

    /**
     * 履歴を１つ戻す
     */
    goBackInHistory({ commit }) {

      let returnParams = {}
      while (true) {
        // 履歴リストから最後の１件を取得
        commit('popHistory')
        returnParams = store.state.qaRelatedInfo.popHistoryReturnParams
        if (returnParams.target && (returnParams.target === 'LG-002' || returnParams.target === 'SNLG-002')) {
          // 「LG-002=法令全文」と「SNLG-002=通達全文」の場合は、
          // 「前へ」の遷移と同じ遷移ではなく、その前のページに戻す。
          // つまり、「LG-002=法令全文」と「SNLG-002=通達全文」以外が返るまで、履歴を遡る
          continue
        }
        break
      }

      // 前にAPIにリクエストしたパラメータ(履歴管理用)を取得した値に設定
      commit('setPrevHistory', returnParams)

      const from = returnParams.from ?? ''
      const relatedInfoTarget = returnParams.target ?? ''
      const relatedInfoKey = returnParams.key ?? ''
      const relatedInfoTitle = returnParams.title ?? ''

      store.dispatch('qaRelatedInfo/setValues', { from: from, target: relatedInfoTarget, key: relatedInfoKey, title: relatedInfoTitle })


      if (returnParams.target === 'current_contents') {
        store.dispatch('qaRelatedInfo/loadCurrentContentsWithParams', { params: returnParams, isHistoryBack: true})
      } else {
        store.dispatch('qaRelatedInfo/loadWLJPContentsWithParams', { params: returnParams, isHistoryBack: true})
      }
    },

    /**
     * チャンクNoを指定したページ遷移
     * @param {number} chunkNumber チャンクNo
     */
    goToPageByChunkNumber({ commit }, { chunkNumber }) {
      store.dispatch('qaRelatedInfo/loadWLJPContents', { chunkNumber })
    },

    /**
     * 現在内容データをロードする(通常遷移の場合)
     */
    loadCurrentContents({ commit }) {

      const params = {}
      params.qa_id = store.state.qa.qaId
      params.search_index_id = store.state.qa.searchIndexId

      store.dispatch('qaRelatedInfo/loadCurrentContentsWithParams', { params: params, isHistoryBack: false })
    },

    /**
     * 現在内容データをロードする
     * @param {object} params
     */
    loadCurrentContentsWithParams({ commit }, { params, isHistoryBack }) {

      // 現在表示されているコンテンツデータがあればクリアする
      commit('clearContentsData')

      commit('setCurrentContentsLoaded', false)

      if (!isHistoryBack) {
        // 履歴を追加
        if (Object.keys(store.state.qaRelatedInfo.prevHistory).length) {
          commit('pushHistory', store.state.qaRelatedInfo.prevHistory)
        }

        // 前にAPIにリクエストしたパラメータ(履歴管理用)として保持
        const additionalParams = {
          target: 'current_contents', // 内容現在のtargetは無いがcurrent_contentsにしておく
          from: store.state.qaRelatedInfo.from,
          title: store.state.qaRelatedInfo.title
        }
        const prevHistory = { ...params, ...additionalParams }
        commit('setPrevHistory', prevHistory)
      }

      // 内容現在一覧APIをコール
      apiQA.listBookExampleRelatedContents(params)
        .then(response => {
          if (response) {
            const { data } = response

            const list = data.list ?? []
            for (let i = 0; i < list.length; i++) {
              list[i].accessTarget = 'LG-006'
            }

            commit('setValue', { key: 'current_contents_message', value: data.message ?? ' - ' })
            commit('setValue', { key: 'current_contents_list', value: list })
          }
        })
        .finally(() => {
          commit('setCurrentContentsLoaded', true)
        })
    },

    /**
     * WLJPのデータをロードする
     * @param {number} chunkNumber チャンクNo
     */
    loadWLJPContents({ commit }, { chunkNumber }) {

      const params = {}
      params.target = store.state.qaRelatedInfo.target
      params.key = store.state.qaRelatedInfo.key
      if (chunkNumber >= 1) {
        params.chunk_number = chunkNumber
      }

      store.dispatch('qaRelatedInfo/loadWLJPContentsWithParams', { params: params, isHistoryBack: false})
    },

    /**
     * 設問印刷しきい値をDBより設定
     */
    setWljpPrintThreshold: ({ state }) => {

      if (state.wljp_print_threshold === 0) {
        // しきい値を取得していない場合

        // 取得できなかったときのデフォルト値設定
        state.wljp_print_threshold = 220000

        if (store.state.common.device === 'sp') {
          // SPは印刷なし
        } else {
          // PCの場合

          // マスタ取得APIをコールししきい値を取得
          const masterParams = {}
          masterParams.key = 'wljp_print_threshold'
          apiCommon.fetchMaster(masterParams)
            .then(response => {
              if (response) {
                const { data } = response

                if (data.list.length > 0) {
                  state.wljp_print_threshold = Number(data.list[0].value1)
                }
              }
            })
        }
      }
    },

    /**
     * WLJPのデータをロードする
     * @param {object} params
     */
    loadWLJPContentsWithParams({ commit }, { params, isHistoryBack }) {

      // しきい値を設定
      store.dispatch('qaRelatedInfo/setWljpPrintThreshold')

      // 現在表示されているコンテンツデータがあればクリアする
      commit('clearContentsData')

      commit('setWLJPContentsLoaded', false)

      if (!isHistoryBack) {
        // 履歴を追加
        if (Object.keys(store.state.qaRelatedInfo.prevHistory).length) {
          commit('pushHistory', store.state.qaRelatedInfo.prevHistory)
        }

        // 前にAPIにリクエストしたパラメータ(履歴管理用)として保持
        const additionalParams = {
          from: store.state.qaRelatedInfo.from,
          title: store.state.qaRelatedInfo.title
        }
        const prevHistory = { ...params, ...additionalParams }
        commit('setPrevHistory', prevHistory)
      }

      // 関連情報・内容現在ページ取得（WLJP連携）APIをコール

      apiQA.fetchBookExampleRelatedPage(params)
        .then(response => {
          if (response) {

            const { data } = response

            if (data.status === 0) {
              // status=0: 成功の場合

              const map = data.response

              if (store.state.qaRelatedInfo.target === 'LG-001') {
                // LG-001=法令の改正リスト

                commit('setValue', { key: 'wljpDataType', value: 'list' })

                const list = map.data

                for (let i = 0; i < list.length; i++) {
                  list[i].accessTarget = 'LG-002' // LG-002=法令全文
                  list[i].accessTarget2 = 'LG-007' // LG-007=内容現在の新旧対照表
                }

                commit('setValue', { key: 'wljpList', value: list })
                
              } else if (store.state.qaRelatedInfo.target === 'LG-002') {
                // LG-002=法令全文

                commit('setValue', { key: 'wljpDataType', value: 'detail' })

                const content = removeNeedlessTagsForWLJP(map.data.content)
                commit('setValue', { key: 'wljpContent', value: content })
                commit('setValue', { key: 'wljpLink', value: map.data.link })

                const pre = map.data.pre ?? ''
                if (pre !== '') {
                  const matched = pre.match(/\bchunkNumber=([0-9]+)/)
                  if (matched && matched.length >= 2) {
                    const wljpPreChunkNumber = Number(matched[1])
                    commit('setValue', { key: 'wljpPreChunkNumber', value: wljpPreChunkNumber })
                  }
                }

                const next = map.data.next ?? ''
                if (next !== '') {
                  const matched = next.match(/\bchunkNumber=([0-9]+)/)
                  if (matched && matched.length >= 2) {
                    const wljpNextChunkNumber = Number(matched[1])
                    commit('setValue', { key: 'wljpNextChunkNumber', value: wljpNextChunkNumber })
                  }
                }

              } else if (store.state.qaRelatedInfo.target === 'LG-003') {
                // LG-003=条文の改正リスト

                commit('setValue', { key: 'wljpDataType', value: 'list' })

                const list = map.data

                for (let i = 0; i < list.length; i++) {
                  list[i].accessTarget = 'LG-004' // LG-004=条文
                }

                commit('setValue', { key: 'wljpList', value: list })

              } else if (store.state.qaRelatedInfo.target === 'LG-004') {
                // LG-004=条文

                commit('setValue', { key: 'wljpDataType', value: 'detail' })

                const content = removeNeedlessTagsForWLJP(map.data.content)
                commit('setValue', { key: 'wljpContent', value: content })
                commit('setValue', { key: 'wljpLink', value: map.data.link })

              } else if (store.state.qaRelatedInfo.target === 'LG-005') {
                // LG-005=改正法

                commit('setValue', { key: 'wljpDataType', value: 'detail' })

                const content = removeNeedlessTagsForWLJP(map.data[0].content)
                commit('setValue', { key: 'wljpContent', value: content })
                commit('setValue', { key: 'wljpLink', value: map.data[0].link })
                commit('setValue', { key: 'wljpLinkFlag', value: content.length < store.state.qaRelatedInfo.wljp_print_threshold })

              } else if (store.state.qaRelatedInfo.target === 'LG-006') {
                // LG-006=内容現在の法令の改正リスト

                commit('setValue', { key: 'wljpDataType', value: 'list' })

                const list = map.data
                const newList = []

                for (let i = 0; i < list.length; i++) {
                  const enforcement = list[i].enforcement
                  const link = list[i].link
                  const id = list[i].id
                  const type = list[i].type

                  const revisionNum = list[i].revision.length

                  for (let k = 0; k < list[i].revision.length; k++) {
                    const map = list[i].revision[k]
                    map.isFirst = (k === 0)
                    map.revisionNum = revisionNum
                    map.accessTarget = 'LG-002' // LG-002=法令全文
                    map.accessTarget2 = 'LG-007' // LG-007=内容現在の新旧対照表
                    map.enforcement = enforcement
                    map.link = link
                    map.id = id
                    map.type = type

                    let guid = ''
                    const versioncomparelaw = map.versioncomparelaw ?? ''
                    const matched = versioncomparelaw.match(/\bguid=([0-9a-zA-Z-]+)/)
                    if (matched && matched.length >= 2) {
                      guid = matched[1]
                    }
                    map.guid = guid
  
                    newList.push(map)
                  }
                }

                commit('setValue', { key: 'wljpList', value: newList })

              } else if (store.state.qaRelatedInfo.target === 'LG-007') {
                // LG-007=内容現在の新旧対照表

                commit('setValue', { key: 'wljpDataType', value: 'detail' })

                const content = removeNeedlessTagsForWLJP(map.data.content)
                commit('setValue', { key: 'wljpContent', value: content })
                commit('setValue', { key: 'wljpLink', value: map.data.link })

              } else if (store.state.qaRelatedInfo.target === 'CA-001') {
                // CA-001=判例

                commit('setValue', { key: 'wljpDataType', value: 'detail' })

                const content = removeNeedlessTagsForWLJP(map.data[0].content)
                commit('setValue', { key: 'wljpContent', value: content })
                commit('setValue', { key: 'wljpLink', value: map.data[0].link })

              } else if (store.state.qaRelatedInfo.target === 'DE-001') {
                // DE-001=裁決

                commit('setValue', { key: 'wljpDataType', value: 'detail' })

                const content = removeNeedlessTagsForWLJP(map.data[0].content)
                commit('setValue', { key: 'wljpContent', value: content })
                commit('setValue', { key: 'wljpLink', value: map.data[0].link })

              } else if (store.state.qaRelatedInfo.target === 'SNLG-001') {
                // SNLG-001=通達全文の改正リスト

                commit('setValue', { key: 'wljpDataType', value: 'list' })

                const list = map.data

                for (let i = 0; i < list.length; i++) {
                  list[i].accessTarget = 'SNLG-002' // SNLG-002=通達全文
                }

                commit('setValue', { key: 'wljpList', value: list })

              } else if (store.state.qaRelatedInfo.target === 'SNLG-002') {
                // SNLG-002=通達全文

                commit('setValue', { key: 'wljpDataType', value: 'detail' })

                const content = removeNeedlessTagsForWLJP(map.data.content)
                commit('setValue', { key: 'wljpContent', value: content })
                commit('setValue', { key: 'wljpLink', value: map.data.link })

                const pre = map.data.pre ?? ''
                if (pre !== '') {
                  const matched = pre.match(/\bchunkNumber=([0-9]+)/)
                  if (matched && matched.length >= 2) {
                    const wljpPreChunkNumber = Number(matched[1])
                    commit('setValue', { key: 'wljpPreChunkNumber', value: wljpPreChunkNumber })
                  }
                }

                const next = map.data.next ?? ''
                if (next !== '') {
                  const matched = next.match(/\bchunkNumber=([0-9]+)/)
                  if (matched && matched.length >= 2) {
                    const wljpNextChunkNumber = Number(matched[1])
                    commit('setValue', { key: 'wljpNextChunkNumber', value: wljpNextChunkNumber })
                  }
                }

              } else if (store.state.qaRelatedInfo.target === 'SNLG-003') {
                // SNLG-003=通達条文の改正リスト

                commit('setValue', { key: 'wljpDataType', value: 'list' })

                const list = map.data

                for (let i = 0; i < list.length; i++) {
                  list[i].accessTarget = 'SNLG-004' // SNLG-004=通達条文
                }

                commit('setValue', { key: 'wljpList', value: list })

              } else if (store.state.qaRelatedInfo.target === 'SNLG-004') {
                // SNLG-004=通達条文

                commit('setValue', { key: 'wljpDataType', value: 'detail' })

                const content = removeNeedlessTagsForWLJP(map.data.content)
                commit('setValue', { key: 'wljpContent', value: content })
                commit('setValue', { key: 'wljpLink', value: map.data.link })
              }


            } else {
              // status=0以外: エラーの場合
              if (store.state.qaRelatedInfo.target === 'LG-006' && data.status === 404) {
                // LG-006=内容現在の法令の改正リスト
                store.dispatch('common/showNotice', { title: '内容現在後の施行', text: data.error_message })
              } else {
                store.dispatch('common/showNotice', { title: 'エラー', text: data.error_message })
              }

            }
        
          }
        })
        .finally(() => {
          commit('setWLJPContentsLoaded', true)
        })
    }
  }
}

export default qaRelatedInfo
